import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Icon from './Icon';

const StarRatingWrapper = styled<any, any>('div')`
    ${propStyles};
`;

StarRatingWrapper.defaultProps = {
};

const StarIcon = styled<any, any>(Icon)`
    ${propStyles};
`;

StarIcon.defaultProps = {
    height: "1em",
    width: "1em"
};

const StarOutlineIcon = styled<any, any>(Icon)`
    ${propStyles};
`;

StarOutlineIcon.defaultProps = {
    height: "1em",
    width: "1em"
};

interface StarRating {
    theme?: any;
    showEmptyStars?: boolean;
    maxRating?: number;
    rating: number;
}

export const StarRating: React.SFC<StarRating> = ({ theme, showEmptyStars, maxRating = 5, rating = 0 }) => {

    const starsArr = showEmptyStars ? Array.from(Array(maxRating).keys()) : [];
    const ratingArr = Array.from(Array(rating).keys()).slice(0, maxRating);

    return (
        <StarRatingWrapper
            {...theme.StarRatingWrapper}
        >
            {
                ratingArr.map((r, i) =>
                    <StarIcon
                        key={i}
                        fileName="MorningstarIcon"
                        {...theme.StarIcon}
                    />
                )
            }
            {
                starsArr.slice(ratingArr.length).map((s, i) =>
                    <StarOutlineIcon
                        key={i}
                        fileName="MorningstarOutlineIcon"
                        {...theme.StarOutlineIcon}
                    />
                )
            }
        </StarRatingWrapper>
    );
};

export default observer(withTheme(StarRating));


// WEBPACK FOOTER //
// ./src/Components/StarRating.tsx